module.exports = __webpack_public_path__ + "img/syl_gallery3.16fd88dc.jpg";